import React from 'react';
import { useNavigate } from 'react-router-dom';

import logoUrl from '@images/logo.svg';
import UserProfile from '@components/UserProfile';

import * as S from './styles';

const Header = () => {
  const navigate = useNavigate();

  const onClickLogo = (): void => {
    navigate('/projekte');
  };

  return (
    <S.StyledBar position='fixed'>
      <S.Header variant='dense' disableGutters>
        <S.Logo onClick={onClickLogo}>
          <img src={logoUrl} alt='logo' />
        </S.Logo>
        <UserProfile customStyles={{ ml: 2.5, marginLeft: 'auto' }} />
      </S.Header>
    </S.StyledBar>
  );
};

export default Header;
